import React from "react";
import Box from "@mui/material/Box";

/**
 * Page footer. Rendered once by AppLayout — previously each page rendered its
 * own copy.
 *
 * Was a white band (specified twice: an inline `backgroundColor: '#fff'` here
 * and `background: #fff` on the styled-components `Nav` in FooterStyles.js)
 * wrapping the LOGO.PNG raster. That raster has a baked-in white background,
 * so it read as a white block once the app went dark. This now matches the
 * sign-in screen's footer treatment: muted text on the page background.
 */
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        padding: "24px var(--container-pad-x)",
        textAlign: "center",
        fontSize: "0.75rem",
        color: "var(--text-faint)",
        borderTop: "1px solid var(--border)",
        marginTop: "auto",
      }}
    >
      Powered by Cauchy Consult © {currentYear}
    </Box>
  );
}
